import React, { useRef } from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import './index.scss'

import PersonalCarousel from './components/personal_carousel/personal_carousel'
import PersonalDescription from './components/personal_desc/personal_desc'
import MainAppBar from './components/appBar/appBar'
import Experience from './components/experience/experience'
import Achievements from './components/achievements/achievement'
import Education from './components/education/education'
import Projects from './components/projects/project'
import Articles from './components/articles/articles'
import articles from './articles/articleIndex'
import Contact from './components/contact/contact'
import Recommendations from './components/recommendations/recommendation'
import FavouriteQuote from './components/fav_quote/fav_quote'

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: { default: '#05070d', paper: '#0b101b' },
    primary: { main: '#7ce8ff' }
  },
  typography: {
    fontFamily: 'Roboto, sans-serif'
  }
})

const App = () => {
  const personalCarouselRef = useRef(null)
  const experienceRef = useRef(null)
  const achievementRef = useRef(null)
  const educationRef = useRef(null)
  const projectRef = useRef(null)
  const articlesRef = useRef(null)
  const contactRef = useRef(null)

  const refs = {
    personalCarouselRef,
    experienceRef,
    achievementRef,
    educationRef,
    projectRef,
    articlesRef,
    contactRef
  }

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <MainAppBar scrollToRef={refs} />

      <main className='site_shell'>
        <section className='hero_section' id='intro'>
          <div className='hero_grid'>
            <div className='hero_copy'>
              <div className='eyebrow'>TECH / STRATEGY / BUILDER</div>
              <PersonalDescription />
              <div className='hero_intro'>
                <p>
                  Tech consultant and problem-solver focused on turning complex systems into products fortune companies can actually use.  
                </p>
                <div className='hero_status'>
                  <span className='status_dot' />
                  AVAILABLE FOR SELECTED OPPORTUNITIES
                </div>
              </div>
            </div>

            <div ref={personalCarouselRef} className='hero_visual'>
              <div className='visual_tag'>01 / FIELD NOTES</div>
              <PersonalCarousel />
            </div>
          </div>

          <div className='metric_rail'>
            <div><strong>36H</strong><span>national hackathon</span></div>
            <div><strong>₹4.5L</strong><span>grant received</span></div>
            <div><strong>2×</strong><span>KPMG internships</span></div>
            <div><strong>06</strong><span>national-level teams lead</span></div>
          </div>
        </section>

        <section className='section_band' ref={experienceRef}>
          <div className='section_kicker'>02 / OPERATING HISTORY</div>
          <Experience />
        </section>

        <section className='section_band section_band_alt' ref={achievementRef}>
          <div className='section_kicker'>03 / VERIFIED HIGHLIGHTS</div>
          <Achievements />
        </section>

        <section className='section_band' ref={educationRef}>
          <div className='section_kicker'>04 / EDUCATION</div>
          <Education />
        </section>

        <section className='section_band section_band_alt' ref={projectRef}>
          <div className='section_kicker'>05 / SELECTED BUILDS</div>
          <Projects />
        </section>

        {articles.length > 0 && (
          <section className='section_band section_band_alt articles_band' ref={articlesRef}>
            <div className='section_kicker'>06 / KNOWLEDGE LOG</div>
            <Articles />
          </section>
        )}

        <section className='section_band recommendations_band'>
          <div className='section_kicker'>{articles.length > 0 ? '07' : '06'} / SIGNAL FROM OTHERS</div>
          <Recommendations />
        </section>

        <section className='contact_band' ref={contactRef}>
          <div className='section_kicker'>{articles.length > 0 ? '08' : '07'} / OPEN CHANNEL</div>
          <Contact />
        </section>

        <FavouriteQuote />
      </main>
    </ThemeProvider>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)

console.log('Portfolio initialized.')
